import email from "../../api/email";

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    sendEmail({ commit }, data) {
      return email
        .sendEmail(data)
        .then((response) => {
          commit("setLoading", false);
          return response;
        })
        .catch((error) => {
          commit("setLoading", false);
          throw error;
        });
    },
  },
};
